import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Box } from '@material-ui/core';
import StyleButton from '../../../../components/StyleButton';
import Dialog from '../../../../components/Dialog';
import Text from '../../../../components/Text';
import { bedStatusAPI } from '../../../../apis';
import { useEnableServiceOrder } from '../../../../utils/hooks';
import { AutoCompleteSelect } from '../../../../components';
import { bedstatusRef } from '../..';
import { getUUID } from '../../../../utils';
import { bsStatusP } from '../../bsApp';
import AddServiceOrders from './AddServiceOrders';

const emptyItem = { text: '', value: '' };

const OrderServicePopup = ({
  handleClose,
  version,
  hospCode,
  wardLocation,
  defaultLocation = '',
  tableId,
  tableName,
  closePop,
  reminder,
  allData,
  defaultCleaningCase,
  defaultRemark = '',
}) => {
  const [orderService, setOrderService] = useState([
    {
      serviceRemark: defaultRemark,
      serviceType: '',
      urgent: false,
      destination: '',
      id: getUUID(),
    },
  ]);
  const [wardCodings, setWardCodings] = useState([]);
  const [serviceLocation, setServiceLocation] = useState('');

  const disabledConfirm = _.some(orderService, (item) => item.serviceType === '') || !serviceLocation;

  const getWardCodingList = async () => {
    try {
      const params = {
        hospCode,
        wardLocation,
      };
      const { result } = await bedStatusAPI.getWardCodingList(params);
      const resultWardCodings = result?.wardCodings;
      setWardCodings(resultWardCodings);

      if (tableName === 'B') {
        setServiceLocation(
          _.find(resultWardCodings, (item) => `${item.ccWardLocation} ${item.ccWardCd}` === defaultLocation)
            ?.location ?? ''
        );
      } else if (resultWardCodings?.length === 1) {
        setServiceLocation(`${resultWardCodings?.[0]?.ccWardLocation} ${resultWardCodings?.[0]?.ccWardCd}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWardCodingList();
  }, []);

  const locationOptions = _.uniqWith(
    [
      emptyItem,
      ..._.map(wardCodings, (item) => ({
        text: item.locationDesc,
        value: item.location,
      })),
    ],
    (itemA, itemB) => itemA.value === itemB.value
  );

  const createCleansingOrder = async () => {
    try {
      const orderServiceList = _.map(orderService, (item) => ({
        destination: item?.destination,
        serviceRemark: item?.serviceRemark,
        serviceType: item?.serviceType,
        urgent: item?.urgent ? 'Y' : 'N',
      }));
      await bedStatusAPI.createCleansing({
        hospCode,
        orderService: orderServiceList,
        tableId,
        tableName,
        version,
        wardLocation,
        serviceLocation,
      });
      closePop();
      bedstatusRef?.current?.reload?.();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog
      open={true}
      title="Order Service"
      cancel="Cancel"
      confirm="Confirm"
      handleCancel={handleClose}
      handleClose={handleClose}
      handleConfirm={createCleansingOrder}
      disabled={disabledConfirm}
    >
      <Text fontSize="1.125rem" color="#2E4469">
        Are you sure to order service for {reminder}?
      </Text>
      <Box display="flex" flexDirection="column" gridGap="0.75rem" mt="1.25rem">
        <Text color="#666666">
          Service Location <span style={{ color: '#FF0300', fontSize: '1rem' }}>*</span>
        </Text>
        <AutoCompleteSelect
          itemList={locationOptions}
          value={serviceLocation}
          onChange={setServiceLocation}
          // 床位是打开的时候不能选
          disabled={tableName === 'B'}
        />
      </Box>
      <AddServiceOrders
        serviceList={orderService}
        setOrderService={setOrderService}
        defaultRemark={defaultRemark}
        defaultCleaningCase={defaultCleaningCase}
      />
    </Dialog>
  );
};

const ServiceOrderBtn = (params) => {
  const [popup, setPopup] = useState(false);
  const { enableOrderService, showOrderServiceBtn, orderServiceBy } = useEnableServiceOrder();

  // 前提条件: 只有当orderServiceBy的值是'ADS'或者'LocalSystem',并且enableOrderService为true,才会有order service button
  // 1、满足前提条件之后,如果床的状态是 TBC / OD 会show order service button, 这两种状态不受showOrderServiceBtn字段控制
  // 2、满足前提条件之后,如果床的状态不是 TBC / OD, 则会根据showOrderServiceBtn字段控制order service button的显示隐藏
  const showBtnBedStatus = [bsStatusP?.['TBC'], bsStatusP?.['DISCHARGING']];
  const showOrderServiceButton = enableOrderService && _.includes(['ADS', 'LocalSystem'], orderServiceBy);

  return (
    <>
      {showOrderServiceButton && (showBtnBedStatus.includes(params?.status) || showOrderServiceBtn) && (
        <StyleButton
          id="bed_order_service_btn"
          width="12.5rem"
          height="2.875rem"
          backgroundColor="#A711AE"
          type="fill"
          borderRadius="0.5rem"
          text="Order Service"
          onClick={() => setPopup(true)}
        />
      )}
      {popup && <OrderServicePopup handleClose={() => setPopup(false)} {...params} />}
    </>
  );
};

export default ServiceOrderBtn;
